import { callAuthorizedGraphQLEndpoint } from '../../../../../../../Module/graphQL'

const updateRestrictedMissionType = async input => {
  const query = `mutation updateUserData($input: UpdateUserInput!){
           updateUserData(input: $input){
               user{
                id
                restrictedMissionType
               } 
            }
        }
  `

  return callAuthorizedGraphQLEndpoint(query, {
    input,
  })
}

export { updateRestrictedMissionType }



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasador/Components/SettingsSection/container/gql.js